// extracted by mini-css-extract-plugin
export var active = "component-module--active--27c25";
export var btnFacebook = "component-module--btn-facebook--77baf";
export var btnLinkedin = "component-module--btn-linkedin--899cf";
export var btnWechat = "component-module--btn-wechat--563df";
export var btnXing = "component-module--btn-xing--b0e03";
export var btnYoutube = "component-module--btn-youtube--a8162";
export var icon = "component-module--icon--4e0d9";
export var iconText = "component-module--icon-text--c02b3";
export var mail = "component-module--mail--be8a7";
export var next = "component-module--next--712bd";
export var page = "component-module--page--44a3b";
export var pager = "component-module--pager--f5127";
export var phone = "component-module--phone--9e96d";
export var prev = "component-module--prev--023f5";
export var printer = "component-module--printer--5c38f";
export var spacer = "component-module--spacer--66f86";